import cn from 'classnames'
import { instanceOf } from 'prop-types'

import Settings from '../../../../../models/settings.js'

export default function CardsCardBanner({ settings }) {
  const {
    postBackgroundColor,
    postColor,
    bannerPrimaryText: bannerTagline,
    bannerSecondaryText: bannerTitle,
    bannerPrimaryFontSize: fontSize,
    bannerPrimaryColor: color,
    bannerSecondaryFontSize,
    bannerSecondaryColor,
  } = settings

  const bannerTaglineStyles = {
    fontSize,
    color,
  }

  const bannerTitleStyles = {
    fontSize: bannerSecondaryFontSize,
    color: bannerSecondaryColor,
  }

  return (
    <div key="cards-card-banner" className="bzfy-o-layout__item bzfy-masonry-item">
      <div
        className={cn('bzfy-c-cardflow-post', { 'bzfy-c-cardflow-post--banner': true })}
        style={{ backgroundColor: postBackgroundColor, color: postColor }}
      >
        <div className="bzfy-o-banner-post">
          <div className="bzfy-o-banner-post__tagline" style={bannerTaglineStyles}>
            {bannerTagline}
          </div>
          <div className="bzfy-o-banner-post__title" style={bannerTitleStyles}>
            {bannerTitle}
          </div>
        </div>
      </div>
    </div>
  )
}

CardsCardBanner.propTypes = {
  settings: instanceOf(Settings).isRequired,
}
